// Launch Info Reference Doc
// https://docs.google.com/document/d/1oPeFixBmG4mZ4CaM6R5P4iAWWj7FO5oX2BRHVZJLe9U/edit

export const REG_INITIAL = 'REG_INITIAL' as const;
export const REG_INITIAL_SHORT = 'REG_INITIAL_SHORT' as const;
export const REG_CONTENT_HOME = 'REG_CONTENT_HOME' as const;
export const REG_STATE_ZERO = 'REG_STATE_ZERO' as const;
export const HOME = 'HOME' as const;
export const STATE_ZERO_OID = 'state-zero';

export type LaunchInfoKey =
	| typeof REG_INITIAL
	| typeof REG_INITIAL_SHORT
	| typeof REG_CONTENT_HOME
	| typeof REG_STATE_ZERO;

export const PX_QUESTIONS_ACCOUNT_TYPE = {
	PERSONAL_BROKERAGE_ACCOUNT: 'PERSONAL_BROKERAGE_ACCOUNT',
	ROBO_PERSONAL_BROKERAGE_ACCOUNT: 'ROBO_PERSONAL_BROKERAGE_ACCOUNT',
	IRA_ACCOUNT: 'IRA_ACCOUNT',
	COMPLETE: 'COMPLETE',
} as const;

export type PxQuestionsAccountType =
	(typeof PX_QUESTIONS_ACCOUNT_TYPE)[keyof typeof PX_QUESTIONS_ACCOUNT_TYPE];

export const LAUNCH_INFO = {
	[REG_INITIAL]: {
		description: 'No Personal Brokerage (PB) Account E-Sign',
		route: '/sign-up',
	},
	[REG_INITIAL_SHORT]: {
		description: 'No Stash Advisory E-Sign, No PB Account E-Sign',
		route: '/sign-up',
	},
	[REG_CONTENT_HOME]: {
		description: 'The Content Moat. Has Stash Advisory E-Sign, No PB Account E-Sign',
		route: '/subscriber-advice/welcome',
	},
	[REG_STATE_ZERO]: {
		route: '/sign-up/state-zero',
	},
} as const;

/* These are the authorized dashboard URLs that users are able to see in the content moat.
   The below structure does NOT support urls with query params 
*/
export const authorizedContentMoatUrls: Record<string, boolean> = {
	'/account-settings': true,
	'/market-insights-report': true,
	'/subscription': true,
	'/plan-details': true, // /subscription and /plan-details point to same screen
	'/data-sharing': true,
	'/manage-subscription/link-payment-method': true,
	'/payment/add-card': true,
	'/add-payment-method': true,
	'/change-payment-method': true,
	'/bank-accounts/new': true,
};

/* These are the authorized dashboard URLs that users are able to see in Home.
   The below structure supports urls with query params (ex: pathname = /cards/:cardUuid/:viewType)
*/
export const authorizedHomeUrls = ['/cards'] as const;

export const isAllowedToRenderWebApp = (): boolean => {
	// Check if current pathname is any of the authorized Content moat urls and return true
	if (authorizedContentMoatUrls[window.location.pathname]) {
		return true;
	}

	// Check if current pathname starts with one of the authorized Home urls and return true
	return authorizedHomeUrls.some((url) => window.location.pathname.startsWith(url));
};

export const isStateZeroPending = (answer: string | null): boolean => {
	return (
		answer === PX_QUESTIONS_ACCOUNT_TYPE.PERSONAL_BROKERAGE_ACCOUNT ||
		answer === PX_QUESTIONS_ACCOUNT_TYPE.ROBO_PERSONAL_BROKERAGE_ACCOUNT ||
		answer === PX_QUESTIONS_ACCOUNT_TYPE.IRA_ACCOUNT
	);
};

export default LAUNCH_INFO;
